/**
 * The world lens — ONE implementation of "test mode shows only test rows,
 * live mode shows only live rows" for every money list in the app.
 *
 * Two collection families, two mechanics:
 *
 * ALWAYS-STAMPED collections (accounts, accounts/transactions,
 * monthly-invoices): every writer has always recorded is_test, so a plain
 * equality works in both directions → use `worldEquality`.
 *
 * LEGACY collections (taps, transfers, withdrawals): documents from before
 * the Test Mode train have NO is_test field, and Firestore equality never
 * matches a missing field — a `== false` clause silently erases history.
 * → use `withWorldLens` on the query (adds the clause ONLY in test mode,
 * where every doc is stamped by construction) plus `belongsToWorld` in the
 * snapshot loop (drops stamped test rows from live views).
 */

/** Query clause for legacy collections: equality only in the test world. */
export const withWorldLens = (query, isTestMode) => (
  isTestMode ? query.where('is_test', '==', true) : query
);

/** Loop filter for legacy collections: absence of the field means live. */
export const belongsToWorld = (doc, isTestMode) => (
  isTestMode ? doc.is_test === true : doc.is_test !== true
);

/** Query clause for always-stamped collections: symmetric equality. */
export const worldEquality = (query, isTestMode) => (
  query.where('is_test', '==', !!isTestMode)
);
